/**
 * Define the face of the cube texture.
 */
export enum TextureCubeFace {
  /** Positive X face for a cube-mapped texture. */
  PositiveX = 0,
  /** Negative X face for a cube-mapped texture. */
  NegativeX = 1,
  /** Positive Y face for a cube-mapped texture. */
  PositiveY = 2,
  /** Negative Y face for a cube-mapped texture. */
  NegativeY = 3,
  /** Positive Z face for a cube-mapped texture. */
  PositiveZ = 4,
  /** Negative Z face for a cube-mapped texture. */
  NegativeZ = 5
}
